<script setup lang="ts">
	import moment from "moment";
import { useEquipStore } from "~/store/equipStore";

	// 예시: SVG 아이콘 (원하는 SVG 코드로 교체)
	const myIconSVG = `
		<svg width="24" height="24" viewBox="0 0 24 24">
			<circle cx="12" cy="12" r="10" fill="#333" />
		</svg>
	`;

	onMounted(() => {
	})

	const props = withDefaults(
		defineProps<{
			apiData?: any;
			property?: any;
			chartParams?: any;
      gradientColor?: string[],
      visibleDataLabel?: boolean;
			units?: string;
			style?: any,
		}>(),
		{
      visibleDataLabel: false,
			units: "",
		}
	);



	const equipStore = useEquipStore();

	const engSource = computed(() => equipStore.selectEquipInfo.engSource);

	// const colors = computed(() => {
	// 	return props.data.map((v, i) => {
	// 		if (i === props.data.length - 1) return "#5963D9";
	// 		else return "#5963D960";
	// 	});
	// });

// 1) 표시할 축 길이 계산
const dateLength = computed(() => {
	// property 존재 여부 확인
	if (!props.property) {
		console.log('⚠️ property가 유효하지 않습니다.');
		return 24; // 기본값
	}
	
	try {
		if (props.property.dateType === 'month') {
			return moment().daysInMonth()
		} else if (props.property.dateType === 'year') {
			return 12
		}
		return 24
	} catch (error) {
		console.error('❌ dateLength 계산 중 오류 발생:', error);
		return 24; // 기본값
	}
})


	const label = computed(() => {
		const arr: string[] = []
		const len = dateLength.value

		if (props.property.dateType === 'year') {
			for (let i = 1; i <= len; i++) arr.push(`${i}월`)
		} else if (props.property.dateType === 'month') {
			for (let i = 1; i <= len; i++) arr.push(`${i}일`)
		} else {
			for (let i = 1; i <= len; i++) arr.push(`${i}시`)
		}
		return arr
	});

	const colors = computed(() => {
		if (!props.chartParams || !Array.isArray(props.chartParams)) {
			return ['#42A5F5']; // 기본 색상
		}
		return props.chartParams.map(v => v.color || '#42A5F5');
	})


	const chartOptions = ref( {
		chart: {
			width: "100%",
			animations: {
				enabled: true,
				speed: 800,
				animateGradually: {
					enabled: true,
					delay: 100
				},
				dynamicAnimation: {
					enabled: true,
					speed: 500
				}
			},
			type: "bar",
			toolbar: {
				autoSelected: 'pan',
				show: false,
			},
			selection: {
				enabled: false,
			},
		},
    title: {
      text: props.property?.title || '차트 제목',
			style:{
				fontSize: '16px',
				fontWeight: 700
			}
    },
    fill:{
      type: 'gradient',
      gradient: {
        type:'vertical',
        inverseColors: true,
        gradientToColors: colors.value,
				// gradientToColors: ['#93B5FF'],
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 20]
      }
    },
		colors: colors.value,
		tooltip: {
			enabled: true,
			shared: true,
			intersect: false,
			hideEmptySeries:false
		},
		grid: {
			show: true,
		
		},
    plotOptions: {
      bar:{
        borderRadius: 2,
        borderRadiusApplication: 'end',
        dataLabels: {
          position: 'top'
        }
      },
    },
		dataLabels: {
      enabled: props.visibleDataLabel,
			style: {
				colors: ["#000"],
			},
		},
		// labels: props.categories,
		labels: label.value,
		xaxis: {
			x: 0,
			tickAmount: 15,
			axisTicks: {
				show: true,
			},
			labels: {
				show: true,
				rotate: 0,
				hideOverlappingLabels: true,
				style: {
					fontSize: "8px",
					fontWeight: 700
				},
			},
		},
		legend: {
			show: false,
			position: "top",
			fontSize: "12px",
			markers: {
				width: 20,
				height: 3,
			},
		},
		yaxis: [
			{
				y: 0,
				showAlways: true,
        decimalsInFloat: 0,
				axisTicks: {
					show: true,
				},
				axisBorder: {
					show: true,
				},
				labels: {
					formatter: (value) => { return commonUtils.isAllStrDataEmpty(value) }
				}
			},
		],
	})



	const seriesName = computed(() => props.chartParams.map(v => v.seriesName))


	const chartData = computed(() => {
		let result = [];
		if(!props.apiData) return [];
		
		let data;

		if(!props.apiData.chartData){
			data = props.apiData;
		} else {
			data = props.apiData.chartData;
		}
		
		for(let i = 0; i < props.chartParams.length; i++){
			if(props.chartParams[i].type === 'prod'){
				result.push(data.map((v: any) => v.values[0]))
			} else if(props.chartParams[i].type === 'usage'){
				result.push(data.map((v: any) => v.values[1]))
			} else if(props.chartParams[i].type === 'revenu'){
				result.push(data.map((v: any) => v.values[10]))
			} else {
				return data.map((v: any) => v.values[0])
			}
		}

		return result;
		// if(props.property.type === 'prod'){
		// 	return props.apiData.chartData.map((v: any) => v.values[0])
		// } else if(props.property.type === 'usage'){
		// 	return props.apiData.chartData.map((v: any) => v.values[1])
		// } else if(props.property.type === 'revenu'){
		// 	return props.apiData.chartData.map((v: any) => v.values[10])
		// } else {
		// 	return props.apiData.chartData.map((v: any) => v.values[0])
		// }
	})

	const series = computed(() => {
		let result = [];

		for(let i = 0; i < chartData.value.length; i++){
			result.push({
				name: seriesName.value[i],
				type: props.chartParams[i].chartType,
				data: chartData.value[i]
			})
		};
		

		if(result.length === 0){
			
			result.push({
				name: 'none',
				type: 'bar',
				data: []
			})
		}

		
		return result;
		
		
		// [
		// 	{
		// 		name: seriesName.value,
		// 		type: "bar",
		// 		data: chartData.value,
		// 	},
		// ];
	});
	console.log("title: ", props.property.title, series, chartOptions.value);

</script>

<template>
  <div class="prod-chart common-card">
    <ClientOnly >
      <apexchart
				type="bar" 
				:options="chartOptions" 
				:series="series" 
				:height="'100%'" 
			/>
			<!-- <div v-else>
				발전량 정보가 존재하지않습니다.
			</div> -->
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/design-toc/prod-chart.scss";
@use "@/assets/styles/design-toc/define_font.scss";
@use "@/assets/styles/design-toc/common-card.scss";

.common-card {
  padding: 0.5rem !important;
}
</style>